import React, { JSX } from 'react';

import { AvatarProps } from '../Avatar';

export const enum ItemType {
  Option = 'option',
  Action = 'action',
  Divider = 'divider',
  NewEntry = 'newEntry',
  Checkbox = 'checkbox',
  Custom = 'custom',
  CustomAction = 'customAction',
}

export interface BaseItem {
  type: ItemType;
  hide?: boolean;
  label: string;
  active?: boolean;
  selected?: boolean;
  suffix?: React.ReactElement;
}

export interface ActionItemType extends BaseItem {
  type: ItemType.Action;
  customLabel?: React.ReactElement;
  icon?: React.ReactElement;
  avatar?: AvatarProps;
  onClick: () => void;
  disabled?: boolean;
  disabledMessageTooltip?: string;
  divider?: boolean;
}

export interface DividerItems extends Partial<BaseItem> {
  type: ItemType.Divider;
}

export interface OptionItemType extends BaseItem {
  type: ItemType.Option;
  disabled?: boolean;
  label: string;
  onChange: (value: boolean) => void;
  value: boolean;
}

export interface NewEntryItemType extends BaseItem {
  type: ItemType.NewEntry;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export interface CheckboxItemType<T> extends BaseItem {
  type: ItemType.Checkbox;
  label: string;
  value: T;
  avatar?: AvatarProps;
  isChecked?: boolean;
  onChange?: (option: T) => void;
  disabled?: boolean;
}

export interface CustomItemType extends BaseItem {
  type: ItemType.Custom;
  render: () => JSX.Element;
}

export interface CustomActionItemType extends BaseItem {
  type: ItemType.CustomAction;
  render: (props: { active: boolean }) => JSX.Element;
  onClick: () => void;
  disabled?: boolean;
}

export type ActionListItem<T = unknown> =
  | ActionItemType
  | OptionItemType
  | DividerItems
  | NewEntryItemType
  | CheckboxItemType<T>
  | CustomItemType
  | CustomActionItemType;
